// extracted by mini-css-extract-plugin
export default {"body":"TableBody_body__XmSR0","empty":"TableBody_empty__f5UDQ"};